import { useQuery } from '@tanstack/react-query';

import { fetchOpenKybProcesses } from 'apis/legitimizer/kyb/api';
import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';

export const useOpenKybProcesses = ({ merchants }: { merchants: Merchant[] }) => {
  const merchantIds = merchants?.map(m => m.itemid.$oid);

  const { data: openKybProcesses, isLoading: isLoadingKybProccesses } = useQuery(
    ['/v1/kyb/merchants/processes/latest', merchantIds],
    () => {
      if (!merchantIds) {
        // Should not end up here, because the query is disabled until merchants have been fetched.
        throw new Error('Merchant IDs not fetched');
      }
      return fetchOpenKybProcesses(merchantIds);
    },
    {
      enabled: !!merchantIds,
      // Set cacheTime to zero to ensure that the user does not get redirected again to KYB after completing it.
      cacheTime: 0,
    },
  );

  return { openKybProcesses, isLoadingKybProccesses };
};
